
        import 'NewPassword.00b0228.css-module'
        export default {"AdminResetPassword":"AdminResetPassword_NewPassword_00b0228","toggle":"toggle_NewPassword_00b0228"}
    